import { XHR } from "./polling-xhr.js";
import { WS } from "./websocket.js";
export const transports = {
    websocket: WS,
    polling: XHR
};



//////////////////
// WEBPACK FOOTER
// ./modules/socketapi/~/engine.io-client/build/esm/transports/index.js
// module id = 417
// module chunks = 0